export default __webpack_public_path__ + "static/media/Blade of the Manic Haze.4d237d7f.jpg";